import React, { Component } from 'react'
import PageBuilderAddElements from './PageBuilderAddElements'
import PageBuilderAddElements2 from './PageBuilderAddElements2'
import PageBuilderHeader from './PageBuilderHeader'
import PageBuilderMain from './PageBuilderMain'
import { formBuilderGroups, FormBuilderObjects } from '../variables/formBuilderData'
import { widgetsList, widgetsGroups } from '../variables/widgetsList'
import inputComponents from '../components/inputs/inputComponents'
import WidgetComponents from '../components/widgets/WidgetComponents'
import ButtonAnimated from '../components/buttons/ButtonAnimated'
import HttpServices from '../utils/Http.services'
import Modal from '../components/Modal'
import { translate } from '../utils/useful'
import SidebarView from '../components/SidebarView'
import FormViewer from '../components/FormViewer'
import TableViewer from '../components/TableViewer'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from '../stores/actionsList';
import IntractionActionsList from '../components/IntractionActionsList'
import Collapsible from 'react-collapsible'
import FixedView from '../components/FixedView'
import moment from 'jalali-moment'
import ClassifierViewerHeader from './ClassifierViewerHeader'


// import { FormBuilderObjects } from '../variables/formBuilderData';

class ClassifierViewer extends Component {
    state = {
        sprints: [],
        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: true },
            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: false },
            { key: 'parent', type: 'SelectInput', information: { label: '{{lang}}parent', address: 'getMyTasks', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false, disabled: true }, showMain: false },
            { key: 'timeline.dueDate', type: 'DateInput', col: '12', information: { label: '{{lang}}desk.Due Date', inplaceEditable: false, placeholder: '{{lang}}desk.Date', required: false }, showMain: true },
            { key: 'categorizer', type: 'CategorizerInput', fullCol: true, information: { label: '{{lang}}Categorizer', inplaceEditable: false, required: false, type: 'api', address: 'getInputOptions', fields: { title: 'label', value: '_id', parent: 'parent', colors: 'colors' }, filter: { applet: '{{appletId}}', frame: '{{frameId}}', appletHub: '{{appletHub}}' }, }, showMain: true, inExport: true },
            { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}desk.priority', inplaceEditable: false, placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#fff', bgColor: '#CA5C72' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#fff', bgColor: '#f5b00f' }, { label: '{{lang}}desk.Low', key: 'low', color: '#fff', bgColor: '#20c676' }], required: false } },
            { key: 'assignee', type: 'GlobalUserInput', information: { label: '{{lang}}Assignee', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
            { key: 'collaborators', type: 'GlobalUserMultiInput', information: { label: '{{lang}}Collaborators', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
        ],
        data: {},
        activeActions: {

            taskList: { key: "tasklist", label: '{{lang}}Task List', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))' },
            planner: { key: "planner", label: '{{lang}}Planner List', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))' },

        },
        isOpen: [],
    }

    componentDidMount() {
        this.init()
        this.props.setHeader({
            // 'toolbar': null,
            'showToolbar': true,
            topHeaderComponent: this.topHeaderComponent,
            // headerIdentityComponent: this.headerIdentityComponent,
            // backAction: () => this.props.changePage('pages')

        })
    }
    init = () => {

        let data = {
            applet: this.props.variables.appletId,
            frame: this.props.page._id
        }
        HttpServices.request('getRecordGroups', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            let sprints = []
            fetchResult.info.map((element) => {
                if (!sprints.includes(element._id)) {
                    sprints.push(element._id)
                }
            })
            this.setState({ sprints: fetchResult.info, data: [], page: this.props.page }, () => {
                this.fetchData(sprints)
            })

        })
    }
    openCollapse = (index) => {
        let isOpen = this.state.isOpen
        if (!isOpen[index]) {
            isOpen[index] = false
        }
        isOpen[index] = !isOpen[index]
        this.setState({ isOpen })
    }
    fetchData = (sprints) => {

        this.setState({ isLoadingData: true })
        let body = this.props.page.filter ? { ...this.props.page.filter } : {}
        let page = this.props.page
        console.log('page', page)
        // body.page = page.key


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }
        // console.log('page.fetchUrl', page.fetchUrl)
        // body.frame = this.props.page?._id
        body.sprint = sprints

        console.log("fetchData67")
        console.log(body)
        console.log(page.fetchUrl)
        // return
        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })

            console.log(fetchResult)
            if (fetchError) {
                // console.log("DKLADKA",fetchError )
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            // console.log('my fetchResult', fetchResult.info)
            let data = {}
            this.state.sprints.map((prop) => {
                fetchResult.info.map((item) => {
                    if (prop._id == item.sprint) {
                        if (!data[prop._id]) {
                            data[prop._id] = []
                        }
                        data[prop._id].push(item)
                    }
                })
            })
            this.setState({ showTable: false }, () => {
                this.setState({ data, showTable: true }, () => {

                    // let keys = ["values.d78c13e6-bbc8-48bc-8ab4-ff22cbb9c06c", "values.d7caac63-ed2e-454b-aaec-8c06c26e0da4", "values.92e053a5-6f21-4e77-b7c2-638749485a33"]
                })
            })
        })
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'PageBuilder') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <div className='px-2'>
                    {/* <PageBuilderAddElements type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} onDragStartAction={this.onDragStartAction} /> */}
                </div>


            </div>

        )
    }
    headerIdentityComponent = () => {
        return (
            <div className='' >
                <input onChange={(e) => this.setName(e.target.value)} value={this.state.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('insert name ...')} />
            </div>

        )
    }
    // setName = (value) => {
    //     this.setState({ name: value })
    // }

    // savePage = () => {
    //     console.log('savePag1', this.state.name)
    //     let content = this.PageBuilderMain.state.content

    //     if (!this.state.name) {
    //         // this.nameModal.showModal()
    //         return
    //     }

    //     let data = {
    //         _id: this.state._id,
    //         type: 'page',
    //         page: content,
    //         applet: this.props.variables.appletId
    //     }

    //     // console.log(data)
    //     this.setState({ data }, () => {
    //         console.log('page', this.props.page)
    //         let page = this.props.page


    //         let isEditing = data._id ? true : false
    //         let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
    //         // data.page = this.props.page?.key
    //         this.setState({ isPostingData: true })

    //         if (page.postBody) {
    //             data = { ...data, ...page.postBody }
    //         }

    //         for (const [key, value] of Object.entries(data)) {
    //             if (/\{\{(.*?)\}\}/.test(value)) {

    //                 if (this.props.variables) {
    //                     data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //                 }
    //             }
    //         }
    //         // data.frame = this.state.currentFrame?._id
    //         // data.features = this.props.applet.features
    //         data.name = this.state.name
    //         // console.log('address', address)
    //         // console.log('data', data)
    //         HttpServices.request(address, data, (fetchResult, fetchError) => {
    //             if (fetchError) {
    //                 this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
    //                 return
    //             }
    //             // console.log([...this.props.baseUrl])


    //             let newLink = this.props.baseUrl.splice(2)
    //             newLink.push(fetchResult?.info?._id)
    //             // console.log(newLink)

    //             this.props.changeWindowLink(newLink)
    //             this.setState({ _id: fetchResult?.info?._id })
    //             // console.log(fetchResult)
    //             this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })



    //         })
    //     })

    // }



    // onDragStartAction = (e) => {
    //     this.PageBuilderMain.onDragStartAction(e)
    // }
    addClicked = () => {
        // console.log('this.props', this.props)
        this.addSprint.open()
    }
    actionClicked = () => {
        console.log('done')

    }
    buttonAction = (sprint, cb) => {
        let data = {}
        data.applet = this.props.variables.appletId
        data.frame = this.props.page._id
        data.mode = { $in: ['tasklist', 'planner'] }
        console.log('filter is', data)
        HttpServices.request('getFrames', data, (fetchResult, fetchError) => {
            console.log('fetchResults', fetchResult.info)
            this.setState({ frames: fetchResult.info, currentSprint: sprint }, () => {
                // this.fixedView.showView()
                if (cb) {
                    cb()
                }
            })
            return
        })

    }
    activeSprint = (item) => {
        let data = {}
        data._id = this.state.currentSprint
        data.applet = this.props.variables.appletId
        data.frame = this.props.page._id
        data.destination = item._id
        // return
        HttpServices.request('activeSprint', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }

        })
    }
    submitForm = () => {
        // return
        let data = this.form.getForm() ?? {}
        data.applet = this.props.variables.appletId
        data.frame = this.props.page._id

        HttpServices.request('postRecordGroup', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            console.log('postRecordGroup', fetchResult)
            let sprints = this.state.sprints
            sprints.push(fetchResult.info)
            this.setState({ sprints })
            this.addSprint.hideModal()
        })
    }

    render() {


        return (
            <div className='w-100 window-content-radius h-100 scroll-no-scrollbar'>
                <div className='w-100 h-100'>
                    {this.state.sprints.map((item) => {
                        return (
                            <div className='mx-3 my-2 '>
                                <ClassifierViewerHeader
                                    sprint={item}
                                    isLoading={this.state.isLoading}
                                    headers={this.state.headers}
                                    data={this.state.data}
                                    actions={this.state.actions}
                                    activeActions={this.state.activeActions}
                                    frames={this.state.frames}
                                    buttonAction={this.buttonAction}
                                    activeSprint={this.activeSprint}
                                />
                            </div>
                        )
                    })}
                    <div style={{ height: '50px' }}></div>
                </div>

                <SidebarView width={this.props.width} zIndex={40} ref={el => this.addSprint = el} >
                    <FormViewer ref={el => this.form = el} headers={this.props?.headers} initData={this.props.initData} formClass="modern" inputClass={'modern-input'} />
                    <ButtonAnimated
                        iconwidth='24px'
                        onClick={this.submitForm}
                        title='submit'
                        icon='/assets/icons/plus-white.svg'
                        textColor={this.props.colors?.textColor}
                        invert={this.props.colors?.iconInvert}
                        bg={'#0871a6'}
                    />
                </SidebarView>
                <div style={{ zIndex: 10, position: 'fixed', bottom: 10, right: 10 }}>
                    <ButtonAnimated
                        iconwidth='24px'
                        onClick={this.addClicked}
                        title='New sprint'
                        icon='/assets/icons/plus-white.svg'
                        textColor={this.props.colors?.textColor}
                        invert={this.props.colors?.iconInvert}
                        bg={this.props.colors?.background ?? '#eee'}
                    />
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ClassifierViewer);